import { render, staticRenderFns } from "./TextGenerate.vue?vue&type=template&id=d126cb92&scoped=true"
import script from "./TextGenerate.vue?vue&type=script&lang=js"
export * from "./TextGenerate.vue?vue&type=script&lang=js"
import style0 from "./TextGenerate.vue?vue&type=style&index=0&id=d126cb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d126cb92",
  null
  
)

export default component.exports